export default __webpack_public_path__ + "static/media/Futura-Bold.75c36912.woff";